import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useFirestoreConnect } from 'react-redux-firebase'
import { uploadCount } from '../../store/actions/redditActions'

function RedditCount(props) {

  useFirestoreConnect([
    { collection: 'reddit' }
  ])

  const dispatch = useDispatch();

  const restaurants = useSelector((state)=>state.firestore.data.restaurants)

  const data = useSelector(
    ({ firestore: { data } }) => data.reddit && data.reddit
  );

  const [dict, setDict] = useState(false)

  useEffect(()=>{
    if(data){
      let countDict = {};
      console.log('data')
      console.log(Object.entries(data))
      let test = Object.entries(data);
      let totalCount = 0;
      for(let itm in test){
        if(!countDict[test[itm][0]]){
          countDict[test[itm][0]] = Object.entries(test[itm][1]['body']).length
          totalCount = totalCount + Object.entries(test[itm][1]['body']).length;
        }
      }
      console.log(countDict)
      console.log('totalCount')
      console.log(totalCount)
      setDict(countDict)
    }
  },[data])
  
  return (
    <div>
      <button className="btn pink lighten-1" onClick={()=>{dict && dispatch(uploadCount(dict))}}>Upload</button>
    </div>
  );
}

export default RedditCount;